import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-64b1d90f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-news-skeleton"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, null, -1));
const _hoisted_3 = {
  class: "img-news"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"image\" data-v-64b1d90f></div><div class=\"line01\" data-v-64b1d90f></div><div class=\"line02\" data-v-64b1d90f></div><div class=\"news-info\" data-v-64b1d90f><div class=\"date\" data-v-64b1d90f></div><div class=\"view\" data-v-64b1d90f></div><div class=\"like\" data-v-64b1d90f></div></div>", 4);
const _hoisted_8 = [_hoisted_4];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, idx => {
    return _createElementVNode("li", {
      key: idx,
      class: "img-news-item"
    }, _hoisted_8);
  }), 64))]), _hoisted_9]);
}